import React from 'react'
import styled from 'styled-components'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import FadeInUpWrapper from '../../common/FadeInUpWrapper'


const Container = styled(FadeInUpWrapper)`
  width: 650px;
  background: white;
  box-shadow: 0 4px 10px -2px rgba(0,0,0,0.3);
`
const Header = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #75AFB6;
  padding: 20px;
`
const Title = styled.div`
  grid-column-start: 2;
  grid-column-end: 2;
  color: white;
  align-self: center;
  justify-self: center;
  font-size: 12pt;
`
const Close = styled.span`
  color: white;
  grid-column-start: 3;
  grid-column-end: 3;
  cursor: pointer;
  justify-self: end;
  align-self: center;
  font-weight: bold;
  font-size: 11pt;
`
const Body = styled.div`
  padding: 20px;
  font-size: 14px;
  font-weight: 600;
`
const URLContainer = styled.div`
  display:flex;
  height: 35åpx;
  padding: 10px 0;
`
const DisabledInput = styled.input`
  border: 1px solid #DBDBDC;
  padding: 5px;
  height: 35px;
  box-sizing: border-box;
  background-color: #F5F5F5;
  flex: 1;
`
const CopyButton = styled.button`
  color: white;
  width: 65px;
  border: none;
  height: 35px;
  display: block;
  background-color: #DC6A00;
`

class EsignUrlModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      request: props.document.signatureRequest ? props.document.signatureRequest[0] : null,
      copied: false
    }
  }
  onCopy = () => {
    this.setState({copied: true})
  }
  render() {
    const { toggleModal, guarantor } = this.props
    const { copied } = this.state
    const signatureRequest = this.props.document.signatureRequests[0]
    const signerName = signatureRequest ? signatureRequest.name : guarantor.name
    return (
      <Container id="esign_url_modal">
        <Header>
          <Title>
            Share With Your Borrower
          </Title>
          <Close id="close_url_modal" onClick={toggleModal}>X</Close>
        </Header>
        <Body>
          <span>Share this link with {signerName} to e-sign the document</span>
          <URLContainer>
            <DisabledInput disabled={true} value={signatureRequest && signatureRequest.url} />
            <CopyToClipboard onCopy={this.onCopy} text={signatureRequest ? signatureRequest.url : ''}>
              <CopyButton id="copy_url">{copied ? 'Copied' : 'Copy'}</CopyButton>
            </CopyToClipboard>
          </URLContainer>
        </Body>
      </Container>
    )
  }
}

export default EsignUrlModal
